import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { styled, alpha } from '@mui/material';

const Tag = (_a) => {
    var { label, inactive, isError } = _a, rest = __rest(_a, ["label", "inactive", "isError"]);
    return (jsx(SquaredTag, Object.assign({ "$inactive": inactive, "$isError": isError }, rest, { children: label })));
};
const SquaredTag = styled("span")(({ theme, $inactive, $isError }) => (Object.assign(Object.assign(Object.assign({ display: "inline-flex", boxSizing: "border-box", borderRadius: 2, padding: theme.spacing(0.25, 0.75), fontSize: 10, fontWeight: 500, lineHeight: "14px", height: "fit-content", textTransform: "uppercase", letterSpacing: 1, textIndent: 1 }, (!$inactive && {
    backgroundColor: alpha(theme.palette.primary[800], 0.1),
    color: theme.palette.primary[800],
    border: `1px solid ${alpha(theme.palette.primary[800], 0.1)}`,
})), ($isError && {
    color: theme.palette.failure.main,
    backgroundColor: alpha(theme.palette.failure.main, 0.1),
    border: `1px solid ${alpha(theme.palette.failure.main, 0.1)}`,
})), ($inactive && {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.ui50}`,
}))));

export { Tag };
//# sourceMappingURL=Tag.js.map
